export default __webpack_public_path__ + "static/media/manage-pos.504c25af.svg";